import React from 'react'
import styled, { keyframes } from 'styled-components'

const Input = styled.input`
  height: 0;
  width: 0;
  opacity: 0;
  z-index: -1;
`

const Label = styled.label`
  position: relative;
  display: inline-block;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  margin: 0.6em 1em;
  padding-left: 2.5em;
  color: white;
  width: 60%;
  p {
    text-align: justify
    margin: 0;
  }

  a {
    color: white;
  }

  @media (max-width: 1560px) {
    width: 80%;
  }

  @media (max-width: 820px) {
    width: 100%;
  }
`

const rotate = keyframes`
 from {
    opacity: 0;
    transform: rotate(0deg);
  }
  to {
    opacity: 1;
    transform: rotate(45deg);
  }
`

const Indicator = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${props => props.color};
  position: absolute;
  top: 0em;
  left: -1em;
  border: 1px solid white;
  border-radius: 0.2em;

  ${Input}:not(:disabled):checked & {
    background: #d1d1d1;
  }

  &::after {
    content: '';
    position: absolute;
    display: none;
  }

  ${Input}:checked + &::after {
    display: block;
    top: 0.1em;
    left: 0.75em;
    width: 35%;
    height: 70%;
    border: solid black;
    border-width: 0 0.2em 0.2em 0;
    transform: rotate(45deg);
    animation-name: ${rotate};
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
  }

  &::disabled {
    cursor: not-allowed;
  }
`

function CheckBox({ value, checked, onChange, name, id, label, disabled }) {
  return (
    <Label htmlFor={id} disabled={disabled}>
      {label}
      <Input
        id={id}
        type="checkbox"
        name={name}
        value={value}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />
      <Indicator color={checked ? '#FFF' : '#fff0'} />
    </Label>
  )
}

export default CheckBox



// WEBPACK FOOTER //
// ./src/components/step/checkbox/checkbox.js